module.exports = __webpack_public_path__ + "static/media/odaiba.92281a58.jpg";